module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_5012.711315d6.png";